import { Button, Form, Input, Layout, Col, Row, Dropdown, Select } from 'antd'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { AuthRequest } from '../../Interfaces/AuthRequest'
import { TranslationKeys } from '../../Constants/TranslationKeys'
import { renderTranslation } from '../../Helpers/GenericHelpers'
import { useNavigateWrapper } from '../../Helpers/NavigateHelper'
import requestToken from '../../Services/TokenService'
import { setTokenToSessionStorage } from '../../Helpers/TokenHelper'
import Logosvg from '../../Components/Svg/logo'
import { setMultiCompanySelected } from 'Slices/Kiosk/ArticleSlice'
import { useCallback, useEffect } from 'react'

const { Content } = Layout

export const Login = () => {
  const dispatch = useAppDispatch()
  const config = useAppSelector(state => state.present.article.serverConfig)
  const user = useAppSelector(state => state.present.configuration.userValue)
  const language = useAppSelector(state => state.present.language.value)
  const multiComp = useAppSelector(state => state.present.article.multiCompany)
  const { navigateToHomepage } = useNavigateWrapper()
  const onFinish = async (values: AuthRequest) => {
    //Ignore user from form and send user in the slice instead.
    values.username = user
    values.companyId = multiComp.active ? multiComp.selected.id : 0
    const response = await requestToken(config, values)
    setTokenToSessionStorage(response.token)
    navigateToHomepage()
  }
  const onFinishFailed = () => {}

  const selectedCompany = useCallback(
    value => {
      dispatch(setMultiCompanySelected(value))
    },
    [dispatch],
  )

  return (
    <Content className='page-content login' id='page-content-login'>
      <Row justify='center' align='middle' style={{ height: '100vh' }}>
        <Col xxl={4} xl={6} lg={8} md={14} sm={16}>
          <div className='pa-5 text-center logo'>
            <Logosvg />
          </div>

          <Form
            name='basic'
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
            layout='vertical'
          >
            <Form.Item
              label={renderTranslation(language, TranslationKeys.usernameLogin)}
              name='username'
              rules={[{ required: true, message: renderTranslation(language, TranslationKeys.usernameRequired) }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={renderTranslation(language, TranslationKeys.passwordLogin)}
              name='password'
              rules={[{ required: true, message: renderTranslation(language, TranslationKeys.passwordRequired) }]}
            >
              <Input.Password />
            </Form.Item>
            {multiComp.active ? (
              <Form.Item>
                <Select defaultValue={multiComp.list[0].name} onChange={selectedCompany}>
                  {multiComp.list.map(e => (
                    <Select.Option key={e.id} value={e.name}>
                      {e.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null}
            <Form.Item>
              <Button type='primary' htmlType='submit' className='login-form-button'>
                {renderTranslation(language, TranslationKeys.submitLogin)}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Content>
  )
}
